import React, { useReducer } from "react";
import { fetchClubs, fetchFitters, fetchLocations } from "../api/ScoringApi";

const clubTypeToFamilys = {
	Drivers: {
		shafts: ["Wood Shaft"],
		heads: ["Driver", "OEM-Driver"],
	},
	Irons: {
		shafts: ["Iron Shaft"],
		heads: ["Irons", "OEM-Irons"],
	},
	Hybrid: {
		shafts: ["HYBRID SHAFT", "Hybrid Shaft", '1Hybrid','2Hybrid','3Hybrid','4Hybrid','5Hybrid','6Hybrid','7Hybrid','8Hybrid','9Hybrid'],
		heads: ["OEM-Hybrid", "Hybrid", "Hybrid Head", "HYBRID HEAD", '1Hybrid','2Hybrid','3Hybrid','4Hybrid','5Hybrid','6Hybrid','7Hybrid','8Hybrid','9Hybrid'],
	},
	Wood: {
		shafts: ["Wood", "Woods", "Wood Shaft", '2Wood', '3Wood', '4Wood', '5Wood', '6Wood', '7Wood', '8Wood', '9Wood'],
		heads: ["OEM-Fairway Wood", "Fairway Wood", "Wood Head", '2Wood', '3Wood', '4Wood', '5Wood', '6Wood', '7Wood', '8Wood', '9Wood'],
	},
	Wedge: {
		shafts: ["Iron Shaft"],
		heads: ['Wedge', 'Wedges', 'OEM-Wedge', "Wedge Head", '50Wedge','52Wedge','54Wedge','56Wedge','58Wedge','60Wedge','SandWedge','PitchingWedge','LobWedge'],
	},
};
const gamerDefaults = {
	Drivers: {
		shaft: {
			id: "-1",
			code: "00000",
			name: "Gamer",
			family: "Wood Shaft",
			manufacturer: "Gamer",
		},
		head: {
			id: "-2",
			code: "00000",
			name: "Gamer",
			family: "Driver",
			manufacturer: "Gamer",
		},
	},
	Irons: {
		shaft: {
			id: "-1",
			code: "00000",
			name: "Gamer",
			family: "Iron Shaft",
			manufacturer: "Gamer",
		},
		head: {
			id: "-2",
			code: "00000",
			name: "Gamer",
			family: "Irons",
			manufacturer: "Gamer",
		},
	},
	Hybrid: {
		shaft: {
			id: "-1",
			code: "00000",
			name: "Gamer",
			family: "Hybrid Shaft",
			manufacturer: "Gamer",
		},
		head: {
			id: "-2",
			code: "00000",
			name: "Gamer",
			family: "Hybrid",
			manufacturer: "Gamer",
		},
	},
	Wood: {
		shaft: {
			id: "-1",
			code: "00000",
			name: "Gamer",
			family: "Wood Shaft",
			manufacturer: "Gamer",
		},
		head: {
			id: "-2",
			code: "00000",
			name: "Gamer",
			family: "Fairway Wood",
			manufacturer: "Gamer",
		},
	},
	Wedge: {
		shaft: {
			id: "-1",
			code: "00000",
			name: "Gamer",
			family: "Iron Shaft",
			manufacturer: "Gamer",
		},
		head: {
			id: "-2",
			code: "00000",
			name: "Gamer",
			family: "Wedge",
			manufacturer: "Gamer",
		},
	},
};
const filterClubInfoByType = (clubType, clubInfo) => {
	var filteredClubInfo = {
		heads: {
			data: [gamerDefaults[clubType].head],
			uniqueFamily: [gamerDefaults[clubType].head.family],
			uniqueMan: ["Gamer"],
		},
		shafts: {
			data: [gamerDefaults[clubType].shaft],
			uniqueFamily: [gamerDefaults[clubType].shaft.family],
			uniqueMan: ["Gamer"],
		},
	};
	clubInfo.forEach((club, index) => {
		if (
			club.family.includes("Shaft") &&
			clubTypeToFamilys[clubType].shafts.includes(club.family)
		) {
			club.id = index;
			filteredClubInfo.shafts.data.push(club);
			if (!filteredClubInfo.shafts.uniqueFamily.includes(club.family)) {
				filteredClubInfo.shafts.uniqueFamily.push(club.family);
			}
			if (!filteredClubInfo.shafts.uniqueMan.includes(club.manufacturer)) {
				filteredClubInfo.shafts.uniqueMan.push(club.manufacturer);
			}
		} else if (clubTypeToFamilys[clubType].heads.includes(club.family)) {
			club.id = index;
			filteredClubInfo.heads.data.push(club);
			if (!filteredClubInfo.heads.uniqueFamily.includes(club.family)) {
				filteredClubInfo.heads.uniqueFamily.push(club.family);
			}
			if (!filteredClubInfo.heads.uniqueMan.includes(club.manufacturer)) {
				filteredClubInfo.heads.uniqueMan.push(club.manufacturer);
			}
		}
	});
	return filteredClubInfo;
};

const contextCreate = (reducer, actions, initialState) => {
	const Context = React.createContext();
	const clubType = localStorage.getItem("clubType") || "Drivers";
	//Check local storage for club information
	if (localStorage.getItem("clubInfo")) {
		var clubsFetchTime = localStorage.getItem("clubFetchDate");
		var expireDate = new Date(parseInt(clubsFetchTime));
		if (new Date().getTime() < expireDate.getTime()) {
			//Filter the clubInfo based on clubType
			initialState.clubInfo = filterClubInfoByType(
				clubType,
				JSON.parse(localStorage.getItem("clubInfo"))
			);
			initialState.fetchedClubInfo = "true";
			if (localStorage.getItem("fitterList")) {
				initialState.fitterInfo = JSON.parse(
					localStorage.getItem("fitterList")
				);
				initialState.fetchedFitters = "true";
			}
			if (localStorage.getItem("LocationList")) {
				initialState.locationInfo = JSON.parse(
					localStorage.getItem("LocationList")
				);
				initialState.fetchedLocations = "true";
			}
		}
	}

	//Based on clubType, auto select the correct Gamer club
	if (clubType === "Irons") {
		initialState.clubType = "Irons";
		initialState.selectedShaft = {
			code: "00000",
			name: "Gamer",
			family: "Iron Shaft",
		};
		initialState.selectedHead = {
			code: "00000",
			name: "Gamer",
			family: "Irons",
		};
	}

	const Provider = ({ children }) => {
		const [clubState, dispatch] = useReducer(reducer, initialState);

		const boundActions = {};
		for (let key in actions) {
			boundActions[key] = actions[key](dispatch, clubState);
		}
		return (
			<Context.Provider value={{ clubState, ...boundActions }}>
				{children}
			</Context.Provider>
		);
	};
	return { Context, Provider };
};

const fittingReducer = (state, action) => {
	switch (action.type) {
		case "get_clubInfo":
			//get Next Monday to set expiration date
			var currentDate = new Date();
			var daysToAdd;
			switch (currentDate.getDay()) {
				case 0:
					daysToAdd = 1;
					break;
				case 1:
					daysToAdd = 7;
					break;
				default:
					//Going from a zero index to a 1 index so need to add 1
					daysToAdd = 7 - currentDate.getDay() + 1;
			}

			localStorage.setItem(
				"clubFetchDate",
				new Date(
					currentDate.getTime() + daysToAdd * 24 * 60 * 60 * 1000
				).getTime()
			);
			return {
				clubInfo: action.payload.clubInfo,
				fetchedClubInfo: action.payload.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: action.payload.selectedShaft,
				selectedHead: action.payload.selectedHead,
				selectedBall: state.selectedBall,
				ballOptions: state.ballOptions,
			};
		case "error_clubInfo":
			return {
				clubInfo: action.payload.clubInfo,
				fetchedClubInfo: action.payload.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: action.payload.selectedShaft,
				selectedHead: action.payload.selectedHead,
				selectedBall: state.selectedBall,
				ballOptions: state.ballOptions,
			};
		case "get_fitterInfo":
			return {
				clubInfo: state.clubInfo,
				fetchedClubInfo: state.fetchedClubInfo,
				fitterInfo: action.payload.fitterInfo,
				fetchedFitters: action.payload.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: state.selectedShaft,
				selectedHead: state.selectedHead,
				selectedBall: state.selectedBall,
				ballOptions: state.ballOptions,
			};
		case "error_fitterInfo":
			return {
				clubInfo: state.clubInfo,
				fetchedClubInfo: state.fetchedClubInfo,
				fitterInfo: action.payload.fitterInfo,
				fetchedFitters: action.payload.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: state.selectedShaft,
				selectedHead: state.selectedHead,
				selectedBall: state.selectedBall,
				ballOptions: state.ballOptions,
			};
		case "get_locationInfo":
			return {
				clubInfo: state.clubInfo,
				fetchedClubInfo: state.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: action.payload.locationInfo,
				fetchedLocations: action.payload.fetchedLocations,
				selectedShaft: state.selectedShaft,
				selectedHead: state.selectedHead,
				selectedBall: state.selectedBall,
				ballOptions: state.ballOptions,
			};
		case "error_locationInfo":
			return {
				clubInfo: state.clubInfo,
				fetchedClubInfo: state.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: action.payload.locationInfo,
				fetchedLocations: action.payload.fetchedLocations,
				selectedShaft: state.selectedShaft,
				selectedHead: state.selectedHead,
				selectedBall: state.selectedBall,
				ballOptions: state.ballOptions,
			};
		case "select_shaft":
			return {
				clubInfo: state.clubInfo,
				fetchedClubInfo: state.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: action.payload,
				selectedHead: state.selectedHead,
				selectedBall: state.selectedBall,
				ballOptions: state.ballOptions,
			};
		case "select_head":
			return {
				clubInfo: state.clubInfo,
				fetchedClubInfo: state.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: state.selectedShaft,
				selectedHead: action.payload,
				selectedBall: state.selectedBall,
				ballOptions: state.ballOptions,
			};
		case "select_ball":
			return {
				clubInfo: state.clubInfo,
				fetchedClubInfo: state.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: state.selectedShaft,
				selectedHead: state.selectedHead,
				selectedBall: action.payload,
				ballOptions: state.ballOptions,
			};
		case "set_ball_options":
			return {
				clubInfo: state.clubInfo,
				fetchedClubInfo: state.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: state.selectedShaft,
				selectedHead: state.selectedHead,
				selectedBall: state.selectedBall,
				ballOptions: action.payload,
			};
		case "club_type_changed":
			return {
				clubInfo: action.payload.clubInfo,
				fetchedClubInfo: action.payload.fetchedClubInfo,
				fitterInfo: state.fitterInfo,
				fetchedFitters: state.fetchedFitters,
				locationInfo: state.locationInfo,
				fetchedLocations: state.fetchedLocations,
				selectedShaft: action.payload.selectedShaft,
				selectedHead: action.payload.selectedHead,
				selectedBall: null, // Reset ball selection when club type changes
				ballOptions: [], // Reset ball options when club type changes
			};
		default:
			return state;
	}
};

const getClubs = (dispatch, clubState) => {
	return async () => {
		if (clubState.fetchedClubInfo !== "true") {
			fetchClubs((response) => {
				if (response.success) {
					localStorage.setItem("clubInfo", JSON.stringify(response.data));
					var clubType = localStorage.getItem("clubType") || "Drivers";
					dispatch({
						type: "get_clubInfo",
						payload: {
							clubInfo: filterClubInfoByType(clubType, response.data),
							fetchedClubInfo: "true",
							selectedShaft: gamerDefaults[clubType].shaft,
							selectedHead: gamerDefaults[clubType].head,
						},
					});
				} else {
					dispatch({
						type: "error_clubInfo",
						payload: {
							clubInfo: [],
							fetchedClubInfo: "error",
							selectedShaft: undefined,
							selectedHead: undefined,
						},
					});
				}
			});
		}
	};
};

const getFitters = (dispatch, clubState) => {
	return async () => {
		if (clubState.fetchedFitters !== "true") {
			fetchFitters((response) => {
				if (response.success) {
					localStorage.setItem("fitterList", JSON.stringify(response.data));
					dispatch({
						type: "get_fitterInfo",
						payload: {
							fitterInfo: response.data,
							fetchedFitters: "true",
						},
					});
				} else {
					dispatch({
						type: "error_fitterInfo",
						payload: {
							fitterInfo: [],
							fetchedFitters: "false",
						},
					});
				}
			});
		}
	};
};

const getLocations = (dispatch, clubState) => {
	return async () => {
		if (clubState.fetchedLocations !== "true") {
			fetchLocations((response) => {
				if (response.success) {
					localStorage.setItem("LocationList", JSON.stringify(response.data));
					dispatch({
						type: "get_locationInfo",
						payload: {
							locationInfo: response.data,
							fetchedLocations: "true",
						},
					});
				} else {
					dispatch({
						type: "error_locationInfo",
						payload: {
							locationInfo: [],
							fetchedlocations: "false",
						},
					});
				}
			});
		}
	};
};

const setSelectedShaft = (dispatch) => {
	return (selectedShaft) => {
		if (selectedShaft) {
			dispatch({ type: "select_shaft", payload: selectedShaft });
		} else {
			var clubType = localStorage.getItem("clubType") || "Drivers";
			dispatch({
				type: "select_shaft",
				payload: gamerDefaults[clubType].shaft,
			});
		}
	};
};

const setSelectedHead = (dispatch) => {
	return (selectedHead) => {
		if (selectedHead) {
			dispatch({ type: "select_head", payload: selectedHead });
		} else {
			var clubType = localStorage.getItem("clubType") || "Drivers";
			dispatch({ type: "select_head", payload: gamerDefaults[clubType].head });
		}
	};
};

const setSelectedBall = (dispatch) => {
	return (selectedBall) => {
		dispatch({ type: "select_ball", payload: selectedBall });
	};
};

const setBallOptions = (dispatch) => {
	return (ballOptions) => {
		dispatch({ type: "set_ball_options", payload: ballOptions });
	};
};

const updateClubType = (dispatch) => {
	return (clubType) => {
		dispatch({
			type: "club_type_changed",
			payload: {
				clubInfo: filterClubInfoByType(
					clubType,
					JSON.parse(localStorage.getItem("clubInfo"))
				),
				fetchedClubInfo: "true",
				selectedShaft: gamerDefaults[clubType].shaft,
				selectedHead: gamerDefaults[clubType].head,
			},
		});
	};
};

export const { Context, Provider } = contextCreate(
	fittingReducer,
	{
		getClubs,
		getFitters,
		getLocations,
		setSelectedShaft,
		setSelectedHead,
		setSelectedBall,
		setBallOptions,
		updateClubType,
	},
	{
		clubInfo: [],
		fetchedClubInfo: "false",
		fetchedFitters: "false",
		fetchedLocations: "false",
		selectedShaft: gamerDefaults["Drivers"].shaft,
		selectedHead: gamerDefaults["Drivers"].head,
		selectedBall: null,
		ballOptions: [],
		clubType: "Drivers",
	}
);
